import { attributes, type HtmlValue, html, joinClasses } from 'BomdisoftComponents/html/index';

export type TooltipPlacement = 'top' | 'bottom' | 'left' | 'right';

export type TooltipOptions = {
  children?: HtmlValue;
  className?: string;
  fill?: boolean;
  id: string;
  placement?: TooltipPlacement;
  testId?: string;
  title: HtmlValue;
  unstyled?: boolean;
};

export const TOOLTIP_TRIGGER_ATTRIBUTE = 'data-bomdisoft-tooltip';

export const hasTooltipTitle = (title: unknown) => title !== null && title !== undefined && title !== '';

export const renderTooltip = ({ children, className, fill = false, id, placement = 'top', testId, title, unstyled = false }: TooltipOptions) => {
  if (!hasTooltipTitle(title)) return html`${children}`;
  return html`<span${attributes({ class: joinClasses('bomdisoft-tooltip-trigger', fill && 'bomdisoft-tooltip-trigger-fill'), [TOOLTIP_TRIGGER_ATTRIBUTE]: placement, 'data-testid': testId })}>${children}</span><div${attributes({ class: joinClasses('bomdisoft-tooltip', !unstyled && 'bomdisoft-tooltip-chrome', className), 'data-placement': placement, id, popover: 'manual', role: 'tooltip' })}>${title}${unstyled ? '' : html`<span aria-hidden="true" class="bomdisoft-tooltip-arrow"></span>`}</div>`;
};
